/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetTranslations$Plain$Params {
  cdnBaseUrl?: string;
  locale?: string;
}

export function getTranslations$Plain(http: HttpClient, rootUrl: string, params?: GetTranslations$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getTranslations$Plain.PATH, 'get');
  if (params) {
    rb.query('cdnBaseUrl', params.cdnBaseUrl, {});
    rb.query('locale', params.locale, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

getTranslations$Plain.PATH = '/api/v1/translations';
